import Button, {ButtonProps} from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import {IconButton, IconButtonProps} from "@mui/material";

export const CIconButton = styled(IconButton)<IconButtonProps>(
  (/* { theme } */) => ({
  }),
);
